import { configureStore } from "@reduxjs/toolkit";
import userManagementReducer from "../features/userManagement/userManagementSlice";
import customerRequestsReducer from "../features/customerRequests/customerRequestsSlice";
import onboardingReducer from "../features/onboarding/onboardingSlice";
import configurationReducer from "../features/configuration/configurationSlice";
import rbacReducer from "../features/rbac/rbacSlice";

const store = configureStore({
  reducer: {
    userManagement: userManagementReducer,
    customerRequests: customerRequestsReducer,
    onboarding: onboardingReducer,
    configuration: configurationReducer,
    rbac: rbacReducer,
  },
});

export default store;
